module.exports = __webpack_public_path__ + "img/Nachdenklich.160db2ef.svg";